import React from 'react';
import { useDispatch } from 'react-redux';
import getHostName from 'helpers/getHostName';
import verifyNewSubdomain from 'fetches/verifyNewSubdomain';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

interface Props {
  value: string;
  error?: string;
  onChange: (field: string, value: any) => void;
}

function Subdomain({ value, error, onChange }: Props) {
  const hostName = getHostName();
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleChange = (e: any) => {
    onChange('client.subdomain', e.target.value);

    dispatch(verifyNewSubdomain(e.target.value));
  };

  return (
    <div className={classes.root}>
      <Typography variant="h6">URL Subdomain</Typography>
      <Typography variant="subtitle2" component="div">
        The URL that will be visible to users on web when visiting Sift and can be used to link to
        Sift from external websites. Note: Your existing subdomain will not continue to work when
        this is changed.
      </Typography>
      <div className={classes.container}>
        <TextField
          className={classes.input}
          id="url subdomain"
          value={value}
          onChange={(e: any) => handleChange(e)}
          inputProps={{ 'aria-label': 'url subdomain', maxLength: 50 }}
          error={!!error}
          helperText={error}
        />
        <Typography className={classes.domain}>{`.${hostName}.com`}</Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  input: {
    minWidth: 250,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  domain: {
    fontSize: theme.typography.body2.fontSize,
    marginLeft: theme.spacing(0.625),
  },
}));

export default Subdomain;
